import React from "react";
import * as s from "./vk-venue.module.css";
import { Background } from "./background/Background";
import { Title } from "./title/Title";
import { Footer } from "./footer/Footer";
import { Cards } from "./cards/Cards";

export const VkVenue = () => {
	return (
		<div className={s.container}>
			<Background />
			<div className={s.content}>
				<Title />
				<Cards />
				<Footer />
			</div>
		</div>
	);
};
